import { get } from 'lodash'

export const headers = (intl = {}, includeCountry) => {
  return [
    intl.formatMessage({
      id: 'table.id'
    }),
    intl.formatMessage({
      id: 'table.first_name'
    }),
    intl.formatMessage({
      id: 'table.last_name'
    }),
    intl.formatMessage({
      id: 'table.previous_level'
    }),
    intl.formatMessage({
      id: 'table.current_level'
    }),
    intl.formatMessage({
      id: 'table.award_unit'
    }),
    intl.formatMessage({
      id: 'table.start_date'
    }),
    intl.formatMessage({
      id: 'table.date_submitted_to_office_signoff'
    }),
    ...(
      includeCountry ? [
        intl.formatMessage({
          id: 'table.country'
        })
      ] : []
    ),
    intl.formatMessage({
      id: 'table.award_signoff_attempts'
    }),
    intl.formatMessage({
      id: 'table.note'
    })
  ]
}

export const line = (data = [], intl = {}, includeCountry) =>
  data.map(item => {
    return {
      line: [
        get(item, 'award.participant.globalId') ||
        get(item, 'award.participant.id'),
        get(item, 'award.participant.firstName'),
        get(item, 'award.participant.lastName'),
        get(item, 'award.previousCompletedAwardLevel.translationText') || '---',
        get(item, 'award.awardLevel.translationText'),
        get(item, 'award.organization.name'),
        get(item, 'award.startDate'),
        get(item, 'award.leaderSignoffDate'),
        ...(includeCountry ? [get(item, 'organization.country.name') || get(item, 'award.organization.country.name')] : []),
        get(item, 'award.signoffRequestAttemptsCount'),
        get(item, 'note')
      ]
    }
  })
